/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Foreignlanguages_Japanisch2Inputs */

const en__field__enum_foreignlanguages_japanisch2 = /** @type {(inputs: _Field__Enum_Foreignlanguages_Japanisch2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Japanisch`)
};

const de__field__enum_foreignlanguages_japanisch2 = /** @type {(inputs: _Field__Enum_Foreignlanguages_Japanisch2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Japanisch`)
};

/**
* | output |
* | --- |
* | "Japanisch" |
*
* @param {_Field__Enum_Foreignlanguages_Japanisch2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_foreignlanguages_japanisch2 = /** @type {((inputs?: _Field__Enum_Foreignlanguages_Japanisch2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Foreignlanguages_Japanisch2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_foreignlanguages_japanisch2(inputs)
	return de__field__enum_foreignlanguages_japanisch2(inputs)
});
export { _field__enum_foreignlanguages_japanisch2 as "_field__enum_foreignLanguages_Japanisch" }